module.exports = __webpack_public_path__ + "static/second_user_image7-7548705b317f33148f7a60a4d34ce1db.jpg";